// extracted by mini-css-extract-plugin
export default {"bottomButtons":"zxSPVhqwGyrEDzwRYv20","bottomButtonsContent":"qqlrw8RsrOWuX_zU3Bpb","newInsertionText":"sIDr02pULFPMvaTDXEkY"};